import { useStaticQuery, graphql } from 'gatsby'
export const useBillsToWatchSA = () => {
  const { allBillDataJson } = useStaticQuery(
    graphql`
      query useBillsToWatchSA {
        allBillDataJson(filter: { bills_to_watch_SA: { eq: true } }) {
          nodes {
            title
            description
            bill_number
            status_id
            body_id
            current_body_id
            pending_committee_id
            main_author
            main_author_party
            sponsors
            dead_bill
            merged_bill
            non_originating_id
            reporter_comment
            reporter_credit
          }
        }
      }
    `
  )
  return allBillDataJson.nodes
}
